const About = () => {
	return (
		<div className='mainContainer'>
			<div className='pageContainer'>
				<p className='pageHeader'>About This Website</p>

				<h3>If you are a non-registered user:</h3>
				<p>
					You can explore the site and see our listing for sale and rent and if
					you like something you can contact the landlord directly with the link
					provided.
				</p>

				<h3>If you are a registered user:</h3>
				<p>
					You can list your property with us (rent or sale), if you forget your
					Email we will send you a link to reset it, you can add as many
					listings as you want and you can update or delete your listing.
				</p>
				<br />
				<p className='pageHeader'> Disclaimer: </p>

				<p>
					This website is fictional and non commercial and may contain
					copyrighted material, the use of which has not been specifically
					authorized by the copyright holders. The material is made available on
					this website as a way to advance research and learning, The material
					is presented for entirely non-profit educational purposes. There is no
					reason to believe that the featured material will in any way
					negatively affect the market value of the copyrighted works. For these
					reasons, we believe that the website is clearly covered under current
					fair-dealing / fair-use copyright laws.
				</p>

				<h3>Fair dealing in United Kingdom law:</h3>
				<p>
					Under the Copyright, Designs and Patents Act 1988 (CDPA), fair dealing
					is limited to the following purposes: research and private study (both
					must be non-commercial), criticism / review / quotation, and news
					reporting (sections 29, 30, 178); as well as parody, caricature and
					pastiche (section 30A) and illustration for teaching. Since 2014 the
					UK has protected the fair dealing exceptions from override by
					contracts or contractual terms and conditions. Contrary to the often
					stated view, the provisions of section 29 of the CDPA do not state the
					amount of an in-copyright work that may be copied for the purposes of
					non-commercial research or private study or to single copies of the
					work, where the copies are made by the researcher or student himself.
				</p>

				<h3>Fair use in the Common law:</h3>
				<p>
					Fair use is a doctrine in law that permits limited use of copyrighted
					material without having to first acquire permission from the copyright
					holder. Fair use is one of the limitations to copyright intended to
					balance the interests of copyright holders with the public interest in
					the wider distribution and use of creative works by allowing as a
					defense to copyright infringement claims certain limited uses that
					might otherwise be considered infringement.[1] Unlike "fair dealing"
					rights that exist in most countries with a British legal history, the
					fair use right is a general exception that applies to all different
					kinds of uses with all types of works and turns on a flexible
					proportionality test that examines the purpose of the use, the amount
					used, and the impact on the market of the original work. The doctrine
					of "fair use" originated in the Anglo-American common law during the
					18th and 19th centuries as a way of preventing copyright law from
					being too rigidly applied and "stifling the very creativity which
					[copyright] law is designed to foster.
				</p>

				<h3>For further information you can visit</h3>
				<p>
					<a
						href='https://www.gov.uk/guidance/exceptions-to-copyright'
						target='_blank'
						rel='noopener noreferrer'
					>
						www.gov.uk/guidance/exceptions-to-copyright
					</a>
					<br />
					<a
						href='https://en.wikipedia.org/wiki/Fair_dealing#United_Kingdom'
						target='_blank'
						rel='noopener noreferrer'
					>
						https://en.wikipedia.org/wiki/Fair_dealing#United_Kingdom
					</a>
					<br />
					<a
						href='https://en.wikipedia.org/wiki/Fair_use'
						target='_blank'
						rel='noopener noreferrer'
					>
						https://en.wikipedia.org/wiki/Fair_use
					</a>
				</p>
			</div>
		</div>
	);
};

export default About;
